// Damaged Products Getters

export const getDamagedProductsList = state => {
  return state.damagedProductsList
}

export const getDamagedProductInfo = state => {
  return state.damagedProductInfo
}

export const getDamagedProductsCount = state => {
  return state.damagedProductsCount
}

export const getUnclosedDamagedProductsCount = state => {
  return state.unclosedDamagedProductsCount
}

export const getDamagedTypes = state => {
  return state.damagedTypes
}

export const getAssetTypes = state => {
  return state.assetTypes
}
